module.exports = __webpack_public_path__ + "img/0xb137c83610d3f0331a48d8d6283864120b4f23a1.76042c51.png";